function dif_calculate(form) {
	// Calculateur/nos-calculateurs-de-niveau-declairage/ Eclairage Diffus (premier calculateur)
	var type_bulb, type_shade, power, length, width, height, rendement, attenuation, area, lux, msg, lang;
	type_bulb=jQuery("input[name='dif_bulb']:checked").val();
	type_shade=jQuery("input[name='dif_shade']:checked").val();

	power=jQuery("input[name='dif_power']").val();
	length=jQuery("input[name='dif_length']").val();
	width=jQuery("input[name='dif_width']").val();
	height=jQuery("input[name='dif_height']").val();
	lang=jQuery("#btn_dif").data("lang");

	jQuery("#dif_calc_message").html("");
	jQuery("input").removeClass("input_error");
	try {
		power=parseFloat(power);
		if(isNaN(power)) {
			msg=(lang==="en")? "the power":"la puissance";
			jQuery("input[name='dif_power']").addClass("input_error");
			throw msg;
		}
		length=parseFloat(length);
		if(isNaN(length) || length===0) {
			msg=(lang==="en")? "the length":"la longueur";
			jQuery("input[name='dif_length']").addClass("input_error");
			throw msg;
		}
		width=parseFloat(width);
		if(isNaN(width) || width===0) {
			msg=(lang==="en")? "the width":"la largeur";
			jQuery("input[name='dif_width']").addClass("input_error");
			throw msg;
		}

		height=parseFloat(height);
		if(isNaN(height) || height===0) {
			msg=(lang==="en")? "the height":"la hauteur";
			jQuery("input[name='dif_height']").addClass("input_error");
			throw msg;
		}
	}

	catch(err) {
		msg=(lang==="en")? "Please enter a non null number for ":"Veuillez entrer un nombre non nul pour ";
		jQuery("#dif_calc_message").html(msg+err);
		jQuery("#dif_lux").html('-');
	}
	
	if (power<0) {
		power=0;
	}

	jQuery("input[name='dif_power']").val(power.toFixed(0));
	jQuery("input[name='dif_length']").val(length.toFixed(1));
	jQuery("input[name='dif_width']").val(width.toFixed(1));
	jQuery("input[name='dif_height']").val(height.toFixed(1));	

	switch(type_bulb) {
		case 'halo_bt':
			rendement=24;
			break;
		case 'halo_ht':
			rendement=18;
			break;
		case 'fluo':
			rendement=60;
			break;
		case 'led':
			rendement=50;
			break;
		default:
			rendement=18;
	}

	switch(type_shade) {
		case 'bare':
			attenuation=0.3;
			break;
		case 'white':
			attenuation=0.45;
			break;
		case 'reflector':
			attenuation=0.7;
			break;
		case 'light':
			attenuation=0.35;
			break;
		case 'dark':
			attenuation=0.20;
			break;
		default:
			attenuation=0.35;
	}

	// CALC DIF
	area=(2*length*width)+(2*length*height)+(2*width*height);
	lux=power*rendement*attenuation/area;
	jQuery("#dif_lux").html(lux.toFixed(0));
}

function dir_calculate(form) {
	// Calculateur/nos-calculateurs-de-niveau-declairage/ Eclairage Dirigé (second calculateur)
	var type_bulb, type_shade, type_shape, power, length, width, rendement, attenuation, area, lux, msg, lang;

	type_bulb=jQuery("input[name='dir_bulb']:checked").val();
	type_shade=jQuery("input[name='dir_shade']:checked").val();
	type_shape=jQuery("input[name='dir_area']:checked").val();
	power=jQuery("input[name='dir_power']").val();
	length=jQuery("input[name='dir_length']").val(); // or diameter
	width=jQuery("input[name='dir_width']").val();
	lang=jQuery("#btn_dir").data("lang");

	jQuery("#dir_calc_message").html("");
	jQuery("input").removeClass("input_error");
	try {
		power=parseFloat(power);
		if(isNaN(power)) {
			msg=(lang==="en")? "the power":"la puissance";
			jQuery("input[name='dir_power']").addClass("input_error");
			throw msg;
		}
		length=parseFloat(length);
		if(isNaN(length) || length===0) {
			msg=(lang==="en")? "the length or diameter":"la longueur ou le diamètre";
			jQuery("input[name='dir_length']").addClass("input_error");
			throw msg;
		}
		width=parseFloat(width);
		if(type_shape!=='round' && (isNaN(width) || width===0)) {
			msg=(lang==="en")? "the width":"la largeur";
			jQuery("input[name='dir_width']").addClass("input_error");
			throw msg;
		}
	}

	catch(err) {
		msg=(lang==="en")? "Please enter a non null number for ":"Veuillez entrer un nombre non nul pour ";
		jQuery("#dir_calc_message").html(msg+err);
		jQuery("#dir_lux").html('-');
	}
	
	if (power<0) {
		power=0;
	}

	jQuery("input[name='dir_power']").val(power.toFixed(0));
	jQuery("input[name='dir_length']").val(length.toFixed(0));
	jQuery("input[name='dir_width']").val(width.toFixed(0));

	switch(type_bulb) {
		case 'halo_bt':
			rendement=24;
			break;
		case 'halo_ht':
			rendement=18;
			break;
		case 'fluo':
			rendement=60;
			break;
		case 'led':
			rendement=50;
			break;
		default:
			rendement=18;
	}

	switch(type_shade) {
		case 'bare':
			attenuation=0.3;
			break;
		case 'white':
			attenuation=0.45;
			break;
		case 'reflector':
			attenuation=0.7;
			break;
		case 'light':
			attenuation=0.35;
			break;
		case 'dark':
			attenuation=.20;
			break;
		default:
			attenuation=0.35;
	}

	// CALC DIR
    if(type_shape==='round') area=Math.PI*(length*length/4)/10000;
    else area=length*width/10000;
	lux=power*rendement*attenuation/area;
	jQuery("#dir_lux").html(lux.toFixed(0));
}

// Trap for dir_calculate: captures when the round shape is selected.
jQuery( "input[name='dir_area']" ).change(function() {
	if(jQuery("#rd10_dir_c").is(':checked')) { 
		jQuery("#dir_c_l").hide(); 
		jQuery("#dir_c_L").html('Diamètre');
	}
	else {
		jQuery("#dir_c_l").show();
		jQuery("#dir_c_L").html('Longueur');
	}
  });

function calculate(form) {
	// Calculateur /guide-pratique/calculez-en-lux-lumen-et-candela/
	var msg, power, type, angle, dist, rendement, lumen, angleRad, candela, lux, rayon, area, diameter, lang;

	power=jQuery("input[name='power']").val();
	type=jQuery("input[name='type']:checked").val();
	angle=jQuery("input[name='angle']").val();
	dist=jQuery("input[name='dist']").val();
	lang=jQuery(".btn-primary").data("lang");

	jQuery("#calc_message").html("");
	jQuery("input").removeClass("input_error");
	try {
		power=parseFloat(power);
		if(isNaN(power)) {
			msg=(lang==="en")? "the power":"la puissance";
			jQuery("input[name='power']").addClass("input_error");
			throw msg;
		}
		angle=parseFloat(angle);
		if(isNaN(angle)) {
			msg=(lang==="en")? "the angle":"l'angle'";
			jQuery("input[name='angle']").addClass("input_error");
			throw msg;
		}
		dist=parseFloat(dist);
		if(isNaN(dist)) {
			msg=(lang==="en")? "the distance":"la distance'";
			jQuery("input[name='dist']").addClass("input_error");
			throw msg;
		}
	}

	catch(err) {
		msg=(lang==="en")? "Please enter a non null number for ":"Veuillez entrer un nombre non nul pour ";
		jQuery("#calc_message").html(msg+err);
		jQuery("#diametre").val('');
		jQuery("#surface").val('');
		jQuery("#flux").val('');
		jQuery("#intensite_candela").val('');
		jQuery("#intensite_lux").val('');
	}
	
	if (power<0) {
		power=0;
	}

	if (angle<0) {
		angle=0;
	}
	else if (angle>360) {
		angle=360;
	}

	switch(type) {
		case 'halogen_bt':
			rendement=24;
			break;
		case 'halogen_ht':
			rendement=18;
			break;
		case 'fluo':
			rendement=60;
			break;
		case 'led':
			rendement=50;
			break;
		default:
			rendement=18;
	}

	lumen=power*rendement;
	angleRad=Math.PI*angle/180;
	candela=lumen/(2*Math.PI*(1-Math.cos(angleRad/2)));
	rayon=dist*Math.tan(angleRad/2);
	diameter=2*rayon;
	area=Math.PI*rayon*rayon;
	lux=lumen/area;

	jQuery("input[name='power']").val(power.toFixed(0));
	jQuery("input[name='angle']").val(angle.toFixed(0));
	jQuery("input[name='dist']").val(dist.toFixed(1));

	jQuery("#diametre").html(diameter.toFixed(2));
	jQuery("#surface").html(area.toFixed(2));
	jQuery("#flux").html(lumen.toFixed(0));
	jQuery("#intensite_candela").html(candela.toFixed(0));
	jQuery("#intensite_lux").html(lux.toFixed(0));	
}